export enum HistoricoAlteracoesProgramaColunasEnum {
    DATA = 'data',
    PROGRAMA = 'programa',
    DETALHES = 'detalhes',
    USUARIO = 'usuario',
}
